import React, { Component } from "react";
import { Link } from "react-router-dom";

import history from "../../../utils/history";

class DefaultLayoutSidebar extends Component {
  state = {
    showToggle: true,
    largeSideBar: false,
    hideSideBar: false,
    items: [],
  };
  historyUnlisten = null;

  updateMenuActive() {
    let currentPath = history.location.pathname;
    const items = this.state.items.map(item => {
      item.active = currentPath.indexOf(item.url) === 0;
      return item;
    });

    this.setState({ items });
  }

  componentWillUnmount() {
    if (this.historyUnlisten) {
      this.historyUnlisten();
      this.unlisten = null;
    }
  }

  componentDidMount() {
    this.updateMenuActive();
    this.historyUnlisten = history.listen(() => {
      this.updateMenuActive();
    });
  }

  toggleSideBarSize() {
    this.setState({ largeSideBar: !this.state.largeSideBar });
  }

  render() {
    let navClass = "sidebar";
    if (!this.state.largeSideBar) {
      navClass += " sidebar-compact";
    }
    if (this.state.hideSideBar) {
      navClass += " sidebar-hide";
    }

    return (
      <nav className={navClass}>
        <ul className="sidebar-menu">
          {this.state.showToggle === true && (
            <li className="sidebar-menu-item">
              <button type="button" onClick={this.toggleSideBarSize.bind(this)}>
                <i className="fa fa-fw fa-bars" />
              </button>
            </li>
          )}

          {this.state.items.map((item, index) => {
            let itemClassName = "sidebar-menu-item";
            if (item.active === true) {
              itemClassName += " active";
            }

            if (item.disabled === true) {
              itemClassName += " disabled";
              return (
                <li key={index} className={itemClassName}>
                  <span>
                    <i className={"fa fa-fw " + item.icon} />
                    <span>{item.text}</span>
                  </span>
                </li>
              );
            }

            return (
              <li key={index} className={itemClassName}>
                <Link to={item.url}>
                  <i className={"fa fa-fw " + item.icon} />
                  <span>{item.text}</span>
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>
    );
  }
}

export default DefaultLayoutSidebar;
